class VhRecalculate {
    constructor() {
        this._init()
    }
    _init() {
        this.reCalcVH()
        window.addEventListener('resize', () => {
            this.reCalcVH()
            // window.dispatchEvent(new Event('swiperUpdate'))
        })
    }
    reCalcVH () {
        const vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
}

export default VhRecalculate